<template>
  <div
    v-if="privacyOption"
    class="mb-8"
  >
    <input
      :id="`${fieldValueId}-privacy`"
      v-model="field.value.attributes.is_private"
      type="checkbox"
      :name="`${fieldValueId}-privacy`"
      value="0"
    >
    <label
      :for="`${fieldValueId}-privacy`"
      v-text="'Do not share'"
    />
  </div>
</template>

<script type="text/babel">
import FieldMixin from  'Base/Resources/assets/js/mixins/FieldMixin'

export default {
  name: 'PrivacyOption',
  mixins: [FieldMixin],
}
</script>
